import { render, staticRenderFns } from "./Churn.vue?vue&type=template&id=6ab31eee&scoped=true"
import script from "./Churn.vue?vue&type=script&lang=js"
export * from "./Churn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab31eee",
  null
  
)

export default component.exports